import { render, staticRenderFns } from "./52.vue?vue&type=template&id=319af34a&scoped=true&"
import script from "./52.vue?vue&type=script&lang=js&"
export * from "./52.vue?vue&type=script&lang=js&"
import style0 from "./52.vue?vue&type=style&index=0&id=319af34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319af34a",
  null
  
)

export default component.exports